export enum PaymentProvider {
  Stripe = 'stripe',
  InternetBank = 'montonio',
  Terminal = 'terminal',
}
